import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";

@Component({
  standalone: false,
  selector: "app-custom-pagination",
  templateUrl: "./custom-pagination.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./custom-pagination.component.scss"]
})
export class CustomPaginationComponent implements OnInit {
  @Input() data: any[];
  @Input() itemsPerPage: number;
  @Input() p: number;
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

  constructor() {}

  ngOnInit(): void {}

  onPageChange(pageNumber: number) {
    this.pageChange.emit(pageNumber);
  }

  public trackByIndex = trackByIndex;
}
